import { TextField } from "@mui/material";
import React, { useState } from "react";
import toList from "../utils/ComponentUtil";
import CustomTabs from "../utils/CustomTabs";
import UnorderedList from "../utils/UnorderedList";
import "./copyPasteContent.scss";

function CopyPasteContent({ editContent, contents }) {

    const [category, setCategory] = useState();
    const [title, setTitle] = useState();
    const [description, setDescription] = useState("Work From Home, Office, College & Anywhere. Work @ your Own free time. 100% Guaranteed Weekly/Monthly Payments thru IMPS/NEFT. No Need any Previous  Experience - 24×7 Customer Support. No Investment required - its completely free to join and work.https://jobfi.in/TSMF1653312038 2022-08-02 21:29:34");

    const handleCategoryChange = (e) => { setCategory(e.target.value); };
    const handleTitleChange = (e) => { setTitle(e.target.value); };
    const handleDescriptionChange = (e) => { setDescription(e.target.value); };

    return (
        <div className="copy-paste-wrp">
            <div className="copy-paste-job-title">Copy Paste Job Details</div>
            <div className="requirement-wrp">
                {toList(contents.requirements, undefined,
                    (req, i) =>
                        <div className="requirement-content">
                            <div className="req-title">{req.title}</div>
                            <div className="req-content">{req.detail}</div>
                        </div>
                )}
            </div>
            <div className="how-todo-wrp">
                <h3>How To Do It</h3>
                <UnorderedList title={contents.howTo.title} compensation={contents.howTo.contents} />
                <CustomTabs tabs={[
                    {
                        label: "Step 1",
                        component: <div className="copy-paste-wrp">
                            <div className="copy-paste-title-wrp">
                                <div className="topic-title">Copy The Ad Content</div>
                            </div>
                            <label>Category</label>
                            <TextField className="rw-url" fullWidth placeholder="Category" value={category} InputLabelProps={{ shrink: false }} onChange={handleCategoryChange}/>
                            <label>Title</label>
                            <TextField className="rw-code" fullWidth placeholder="Title" value={title} InputLabelProps={{ shrink: false }} onChange={handleTitleChange}/>
                            <label>Description</label>
                            <TextField id="outlined-multiline-flexible"
                                placeholder="Enter Description"
                                fullWidth
                                multiline
                                value={description}
                                rows={5}
                                InputLabelProps={{ shrink: false }}
                                onChange={handleDescriptionChange}
                            />
                            <div className="copy-paste-note-wrp">
                                <div className="note-title">Note</div>
                                <UnorderedList title={""} compensation={contents.notes} />
                            </div>
                            <div className="save-content-btn-wrp">
                                <div className="save-content-btn hbw-button" onClick={() => { }}>Next Step</div>
                            </div>
                        </div>
                    },
                    {
                        label: "Step 2",
                        component: <div className="copy-paste-job-step-2-wrp">
                            <UnorderedList title={"Paste The Ad Content"} compensation={[
                                'Search "Free Classifieds" on google.com. You will See More Number of Classified websites.',
                                'Open any of the Classified website, Find & Click the "Post Free Ad" Button on those websites.',
                                'Choose the Related Category that matches your Given Advertisement Category.',
                                'Paste the Above Copied Ad Content & Submit into that Classified Websites.',
                                'After the Submission, your Ad will be Activated Immediately.In Some Cases , the Activation link for your Ad will be Sent to your E-mail Address.',
                                'Thats all.Just Copy that Webpage Address where your Ad appears Successfully.'
                                ]} />
                        </div>
                    },
                    {
                        label: "Step 3",
                        component: <div>copy the ad content 3</div>
                    }
                ]} />
            </div>
        </div>
    );
};
export default CopyPasteContent;